// ---- ICONS - Small ----
import mailchimp_small from 'assets/images/integrations/avator_mailchimp_logo.png';
import sendgrid_small from 'assets/images/integrations/graas_logo_small.svg';
import GoogleAds_small from 'assets/images/integrations/google-ads-fevicon.svg';
import GoogleAnalytics_small from 'assets/images/integrations/google-analytics-fevicon.svg';
import FacebookAds_small from 'assets/images/integrations/facebookAds-fevicon.svg';
import GoogleSearchConsole_small from 'assets/images/integrations/google-console-fevicon.svg';
import Shopify_small from 'assets/images/integrations/shopify-fevicon.svg';
import Shopee_small from 'assets/images/integrations/shopee-favicon.svg';
import Lazada_small from 'assets/images/integrations/lazada-fevicon.svg';
import amazon_small from 'assets/images/integrations/avator_Amazon_logo.png';
import flipkart_small from 'assets/images/integrations/avator_flipkart_logo.png';
import zalora_small from 'assets/images/integrations/zalora_favicon.png';
import tokopedia_small from 'assets/images/integrations/avator_tokopedia_logo.png';
import jd_small from 'assets/images/integrations/avator_jd_logo.png';
import tiki_small from 'assets/images/integrations/avator_tiki_logo.png';
import blibli_small from 'assets/images/integrations/avator_blibli_logo.png';
import tiktok_small from 'assets/images/integrations/avator_tiktok_logo.png';
import eleven_street_small from 'assets/images/integrations/avator_elevenStreet_logo.png';
import etsy_small from 'assets/images/integrations/avator_etsy_logo.png';
import qoo10_small from 'assets/images/integrations/avator_qoo10_logo.png';
import ebay_small from 'assets/images/integrations/avator_ebay_logo.png';
import bukalapak_small from 'assets/images/integrations/avator_bukalapak_logo.png';
import salesforce from 'assets/images/integrations/large/salesforce.png';
import nykaaLogo from 'assets/images/integrations/nykaa.png';
import lighthouseLogo from 'assets/images/integrations/avator_lighthouse_logo.png';
import offlineLogo from 'assets/images/integrations/avator_offline_logo.png';
import myntraLogo from 'assets/images/integrations/Myntra.jpg';
import noLogo from 'assets/images/integrations/no-logo.png';
import MagentoLogo from 'assets/images/integrations/avator_magento_logo.png';
import wooCommerceLogo from 'assets/images/integrations/avator_Layer-1.png';
import tiktokAdsLogo from 'assets/images/integrations/listview/tiktokAds.png';
import amazonAdsLogo from 'assets/images/integrations/listview/amazonAds.png';

export const channelToLogo = {
  facebookAds: {
    small: FacebookAds_small,
    title: 'Facebook Ads'
  },
  googleAnalytics: { small: GoogleAnalytics_small, title: 'Google Analytics' },
  googleAds: { small: GoogleAds_small, title: 'Google Ads' },
  googleSearchConsole: { small: GoogleSearchConsole_small, title: 'Google Search Console' },
  shopify: { small: Shopify_small, title: 'Shopify' },
  shopee: { small: Shopee_small, title: 'Shopee' },
  lazada: { small: Lazada_small, title: 'Lazada' },
  mailchimp: { small: mailchimp_small, title: 'Mailchimp' },
  sendgrid: { small: sendgrid_small, title: 'SendGrid' },
  amazon: { small: amazon_small, title: 'Amazon' },
  flipkart: { small: flipkart_small, title: 'Flipkart' },
  zalora: { small: zalora_small, title: 'Zalora' },
  tokopedia: { small: tokopedia_small, title: 'Tokopedia' },
  jd: { small: jd_small, title: 'JD' },
  tiki: { small: tiki_small, title: 'Tiki' },
  blibli: { small: blibli_small, title: 'Blibli' },
  tiktok: { small: tiktok_small, title: 'Tiktok' },
  eleven_street: { small: eleven_street_small, title: 'Eleven Street' },
  etsy: { small: etsy_small, title: 'Etsy' },
  qoo10: { small: qoo10_small, title: 'Qoo10' },
  ebay: { small: ebay_small, title: 'Ebay' },
  bukalapak: { small: bukalapak_small, title: 'Bukalapak' },
  myntra: { small: myntraLogo, title: 'Myntra' },
  noLogo: { small: noLogo, title: 'noImage' },
  wooCommerce: { small: wooCommerceLogo, title: 'wooCommerce' },
  magento: { small: MagentoLogo, title: 'magento' },
  salesforce: { small: salesforce, title: 'salesforce' },
  nykaa: { small: nykaaLogo, title: 'nykaa' },
  offline: { small: offlineLogo, title: 'Offline' },
  lighthouse: { small: lighthouseLogo, title: 'Lighthouse' },
  tiktokAds: { small: tiktokAdsLogo, title: 'Tiktok Ads' },
  amazonAds: { small: amazonAdsLogo, title: 'Amazon Ads' }
};
